import React from 'react'
import CustomerSettingsContainer from 'containers/panel/customer/settings-container'

const SettingsPage = () => {
  return (
    <CustomerSettingsContainer/>
  )
}

export default SettingsPage